module.exports = __webpack_public_path__ + "8d5524b64007f8c6d6ed14a367e14a6e.svg";